module.exports = __webpack_public_path__ + "static/media/step1.8aed38a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/sber/step1.jpg
// module id = 704
// module chunks = 0